import { useEffect } from 'react'
import * as C from './styles.js'
import { Link } from 'react-router-dom'
import { useState } from 'react';
import { ErrorMessage } from '../styles.js';
import { collection, getDocs, getFirestore, query, where } from 'firebase/firestore';
import { AppFirebase } from '../../../config/firebase.js';

export default function CollectionTv({ movie, all_movies }) {

    const [ moviesLengthVisible, setMoviesLengthVisible ] = useState(20);
    const [ movies, setMovies ] = useState();
    const [ loadingMovies, setLoadingMovies ] = useState(true);
    
    const database = getFirestore(AppFirebase);

    useEffect(()=>{
        setMoviesLengthVisible(20);
    }, [movies]);
    
    const converter = (minutos) => {
        const horas = Math.floor(minutos/ 60);
        const min = minutos % 60;
        const textoHoras = (`${horas}`);
        const textoMinutos = (`${min}`);

        if (minutos <= 59) {
            return `${textoMinutos}min`;
        } else if (minutos == 60) {
            return `${textoHoras }h`;
        } else if (minutos >= 61) {
            return `${textoHoras }h, ${textoMinutos}min`;
        }
    };

    const loadMore = () => {
        const remainingMovies = movies?.length - moviesLengthVisible;
        const nextBatch = Math.min(remainingMovies, 10);
        setMoviesLengthVisible(prevCastLengthVisible => prevCastLengthVisible + nextBatch);
    };

    useEffect(() => {

        if (all_movies?.movies?.length > 0) {
            const moviesFiltered = all_movies?.movies?.filter((movieItem) => {
                return movieItem?.movie_subcollection_id == movie?.movie_subcollection_id;
            });
    
            setMovies(moviesFiltered)
        }

    }, [movie, all_movies]);

    return (
        <C.Container layoutStyle={'grid'}>
            <div className='container-movies'>
                {movies?.slice(0, moviesLengthVisible).reverse().map((movie_collection, index) => {

                    const isDisabled = movie?.id_tmdb == movie_collection?.id_tmdb

                    return (
                        <Link isDisabled={isDisabled} className='movie' to={`/details/movie/${movie_collection?.id_tmdb}/${movie_collection?.id_imdb}`} key={index}>
                            <div className='container-image'>
                                <img src={`https://image.tmdb.org/t/p/w400${movie_collection?.backdrop_path}`} alt={`imagem do filme ${movie_collection?.name}`} />
                            </div>
                            <div className='details'>
                                <h2 title={movie_collection?.name} className='name'>{/*index + 1*/} {movie_collection?.name}</h2>
                                <section>
                                    {movie_collection?.media_type && <span className='type'>{movie_collection?.media_type == "tv" ? "SÉRIE" : "FILME"}</span>}
                                    {movie_collection?.more_details?.vote_average > 0 && <span><i className='fas fa-star'></i> {movie_collection?.more_details?.vote_average.toFixed(1)}</span>}
                                    {(movie_collection?.more_details?.release_date || movie_collection?.more_details?.first_air_date) && <span><i className="fas fa-calendar"></i> {(movie_collection?.more_details?.release_date).slice(0,4) || (movie_collection?.more_details?.first_air_date).slice(0,4)}</span>}
                                </section>
                                <p className='overview'>{movie_collection?.overview}</p>
                            </div>
                        </Link>
                    )
                })}
            </div>
            {(movies?.length === 0 && !loadingMovies) && (
                <ErrorMessage margin={'20px 0 0 0'}>
                    <p><i className='fas fa-triangle-exclamation'></i> Nenhuma coleção encontrada. tente novamente!</p>
                </ErrorMessage>
            )}
            {!loadingMovies && (movies?.length > moviesLengthVisible) && (
                <section className="section-more-movies">
                    <button onClick={loadMore}><i className="fas fa-plus"></i></button>
                </section>
            )}
        </C.Container>
    );
}